import React from 'react';
import { BankStatementsResult, LogBankStatementsEventInput, useLogBankStatementsEventMutation, useRecordBankStatementsResultMutation } from '../../generated.graphql';


const allowedOrigins = [
  'https://test.bankstatements.com.au',
  'https://www.bankstatements.com.au',
  'https://bankstatements.com.au',
];


const COMPLETE = 'COMPLETE';
const LOGIN_FAIL = 'LOGIN_FAIL';
const ERROR = 'ERROR';


const enums = {
  [COMPLETE]: BankStatementsResult.Complete,
  [LOGIN_FAIL]: BankStatementsResult.LoginFail,
  [ERROR]: BankStatementsResult.Error,
}


type CompletedCommand = typeof COMPLETE | typeof LOGIN_FAIL | typeof ERROR;


interface UseBankStatements {
  onComplete: (command: CompletedCommand) => void;
  portalSlug: string;
  reference: string;
}


export const useBankStatements = (config: UseBankStatements) => {

  const [, recordResult] = useRecordBankStatementsResultMutation();
  const [, logEvent] = useLogBankStatementsEventMutation();

  // TODO: Test this!
  React.useEffect(() => {

    // LISTEN FOR MESSAGES from the BankStatements iframe
    const receiveMessage = async (event: MessageEvent<string>) => {

      // console.log('A message was received:', event)

      // Do we trust the sender of this message?  (might be
      // different from what we originally opened, for example).
      if (allowedOrigins.indexOf(event.origin) === -1)
        return;


      console.log('BANK STATEMENTS COMMAND:', event.data);
      
      // Simple mode (this will be replaced by advanced mode soon)
      if (event.data === COMPLETE || event.data === LOGIN_FAIL || event.data === ERROR) {
        // TODO: Test this, and probably need to look at the result of the mutation
        await recordResult({
          resultInput: {
            portalSlug: config.portalSlug, 
            reference: config.reference, 
            result: enums[event.data],
          },
          eventInput: {
            event: 'submission_complete',
            reference: config.reference, 
            portalSlug: config.portalSlug,
            data: event.data,
          }
        });
        config.onComplete(event.data);
      }

      else {
        // Try and JSON parse the payload
        try {
          const j = JSON.parse(event.data);

          const eventInput: LogBankStatementsEventInput = {
            reference: config.reference,
            portalSlug: config.portalSlug,
            event: j.event || '?',
            data: (j.data || '').toString(),
            status: (j.status || '').toString(),
            errorCode: j.error_code || null,
            errorMessage: j.error_message || null,
          }

          if (j.event === 'submission_complete') {
            const resultValue = j.status === 'success' ? 'COMPLETE' : 'ERROR';
            const resultEnum = enums[resultValue]
            // Record result and event data, using our 2x mutation
            await recordResult({
              resultInput: {
                portalSlug: config.portalSlug, 
                reference: config.reference, 
                result: resultEnum,
                errorCode: eventInput.errorCode,
                errorMessage: eventInput.errorMessage,
              },
              eventInput,
            });
            config.onComplete(resultValue);
          }
          else {
            // Just record event data
            await logEvent({input: eventInput});
          }
        }
        catch (e) {
          console.warn('could not decode JSON');
        }
      }

    };

    // Start listening at the start
    window.addEventListener("message", receiveMessage, false);
    return () => {
      // Stop listening when unmounted
      window.removeEventListener("message", receiveMessage);
    }
  // eslint-disable-next-line
  }, [config, recordResult])
};
